import React from 'react';
import { useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { AUTO_LOAN_VERTICAL } from 'types/marketplaceTiles.constants';
import { AUTO_PURCHASE_OCF } from 'types/morph.pagePosition.constants';
import PageLoadingMask from 'components/masks/PageLoadingMask';
import AutoPurchaseOcfModuleView from './AutoPurchaseOcfModuleView';
import { MIN_NEW_AUTOLOAN, MAX_NEW_AUTOLOAN } from 'helpers/autoLoan.helper';

const AutoPurchaseOcfModuleController = props => {
  const { globalLoadingFlag } = props;

  const loading = globalLoadingFlag;

  const trackingAtr = getViewModuleTrackingAttributes({
    moduleName: AUTO_PURCHASE_OCF,
    modulePosition: props.modulePosition,
    vertical: AUTO_LOAN_VERTICAL,
  });

  const seenModuleTracking = useSeenModulePixel(trackingAtr);

  if (loading) {
    return <PageLoadingMask />;
  } else {
    return (
      <>
        {seenModuleTracking}
        <AutoPurchaseOcfModuleView
          {...props}
          MIN_NEW_AUTOLOAN={MIN_NEW_AUTOLOAN}
          MAX_NEW_AUTOLOAN={MAX_NEW_AUTOLOAN}
          hideDisclaimer={true}
        />
      </>
    );
  }
};

export default AutoPurchaseOcfModuleController;
